import React from "react";
import { motion } from "framer-motion";
import { styles } from "../styles";

const Collaboration = ({ animations, isMobile }) => {
  return (
    <motion.section
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.2 }}
      className="relative py-16 md:py-24 bg-cover bg-center"
      style={{
        backgroundImage: "url('images/landing/bg.png')",
        backgroundAttachment: isMobile ? "scroll" : "fixed",
      }}
    >
      <div className={`${styles.overlay} bg-black/80`} />
      <div className={`relative ${styles.container}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <motion.div variants={animations.slideIn} className="relative h-full">
            <img
              src="/images/landing/collaboration.jpg"
              alt="Collaboration"
              className="w-full h-full rounded-lg object-contain"
              loading="lazy"
            />
          </motion.div>

          <motion.div variants={animations.fadeInUp} className="text-white">
            <h3 className="text-primary font-barlow-medium text-xl md:text-2xl mb-4">
              Kerjasama Strategis
            </h3>
            <h2 className={`${styles.sectionTitle} mb-6`}>
              Mari Berkolaborasi untuk Menciptakan Nilai
            </h2>
            <p className="text-gray-300 mb-8 md:mb-12 leading-relaxed text-sm md:text-base">
              Kami percaya bahwa kolaborasi adalah kunci kesuksesan dalam
              menciptakan solusi inovatif. Mari jalin kemitraan strategis untuk
              mewujudkan visi bersama.
            </p>

            <div variants={animations.fadeInUp}>
              <a
                href="/contact"
                className={`${styles.button} inline-block text-white px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg font-semibold`}
              >
                Hubungi Kami
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default Collaboration;
